module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-toolbar-title', [_c('h2', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("View Campaign Brief")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isClient) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openAMCCInputsDialog()
      }
    }
  }, [_vm._v("\n          AM, CC Inputs\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue-grey",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.savePDF()
      }
    }
  }, [_c('v-icon', [_vm._v("get_app")]), _vm._v("Download PDF\n        ")], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body",
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, _vm._l((_vm.campaignModelSections), function(section) {
    return _c('v-layout', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "hover": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewComments(section)
        }
      }
    }, [_c('v-toolbar', {
      attrs: {
        "dense": "",
        "flat": ""
      }
    }, [_c('v-toolbar-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-badge', {
      attrs: {
        "value": section.unreadComments.length,
        "content": section.unreadComments.length,
        "color": "green",
        "overlap": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewComments(section)
        }
      }
    }, [_c('v-btn', [_c('v-icon', {
      attrs: {
        "color": section.unreadComments.length == 0 ? 'secondary' : 'red'
      }
    }, [_vm._v("chat")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [(
      (section.type === _vm.campaignModelSectionType.CAMPAIGN_SUMMARY) ||
      (section.type === _vm.campaignModelSectionType.INFLUENCER_SELECTION) ||
      (section.type === _vm.campaignModelSectionType.BUDGET_ALLOCATION) ||
      (section.type === _vm.campaignModelSectionType.VIDEO_BRIEF && _vm.showVideoBrief)) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [(campaignField.type === 'text' && campaignField.name === 'vertical' && !_vm.isClient) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', _vm._l((_vm.selectedCampaignVertical), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          on: {
            "click:close": function($event) {
              return _vm.removeChip(index)
            }
          }
        }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                        ")])
      }), 1)]) : (_vm.campaign[campaignField.name] && (campaignField.type === 'text' && campaignField.name !== 'vertical') && (campaignField.name !== 'dont' || _vm.hideRequiredActions()) && _vm.campaign[campaignField.name] !== '' || (campaignField.type === 'slider' && _vm.campaign[campaignField.name] !== '')) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'combobox' && _vm.campaign[campaignField.name] && _vm.campaign[campaignField.name].length > 0) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (Array.isArray(_vm.campaign[campaignField.name]) && campaignField.name !== 'targetLocation') ? _c('div', _vm._l((_vm.campaign[campaignField.name]), function(value) {
        return _c('v-chip', {
          key: value,
          staticClass: "ma-2"
        }, [_vm._v(_vm._s(value))])
      }), 1) : (Array.isArray(_vm.campaign[campaignField.name]) && campaignField.name === 'targetLocation') ? _c('div', _vm._l((_vm.campaign[campaignField.name]), function(value) {
        return _c('v-chip', {
          key: value,
          staticClass: "ma-2"
        }, [_vm._v(_vm._s(value))])
      }), 1) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.campaign[campaignField.name]))])])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea' && _vm.campaign[campaignField.name] !== '') ? _c('div', [((campaignField.name !== 'visualMust' &&
        campaignField.name !== 'copyMust') || _vm.hideRequiredActions()) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', {
        staticStyle: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (campaignField.type === 'select' && _vm.campaign[campaignField.name] && _vm.campaign[campaignField.name] != 'No preference' && (campaignField.name === 'gender' || campaignField.name === 'targetGender' || _vm.hideRequiredActions())) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'ioNumbers') ? _c('p', [_vm._v(_vm._s((_vm.campaign[campaignField.name] ? _vm.campaign[campaignField.name] : '-')))]) : (campaignField.name === 'name') ? _c('p', [_vm._v(_vm._s((_vm.campaign[campaignField.name] ? _vm.campaign[campaignField.name] : '-')) + " "), (_vm.campaign.campaignCode) ? _c('span', [_vm._v("(" + _vm._s(_vm.campaign.campaignCode) + ")")]) : _vm._e()]) : _c('p', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'autocomplete' && _vm.campaign[campaignField.name]) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCountryDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'chips' && _vm.campaign[campaignField.name]) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', _vm._l((_vm.campaign[campaignField.name]), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "value": item,
            "filter": ""
          }
        }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])
      }), 1)]) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && _vm.campaign[campaignField.name] !== '') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', [_c('a', {
        staticClass: "campaign-image",
        attrs: {
          "href": _vm.constructImageURL(_vm.campaign[campaignField.name]),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "src": _vm.constructImageURL(_vm.campaign[campaignField.name])
        }
      })])])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'radio' && (campaignField.name === 'revenueCalculation' && _vm.hideRequiredActions()) && _vm.campaign[campaignField.name] !== undefined && _vm.campaign[campaignField.name] !== '') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_c('v-chip', [_vm._v(_vm._s(_vm.campaign[campaignField.name] === undefined || _vm.campaign[campaignField.name] === '' ? 'CONTENT' : _vm.campaign[campaignField.name].toUpperCase()))])], 1)]) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.CONTENT_ANGLE) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'select' && ((campaignField.name === 'actionRequired_time' ||
        campaignField.name === 'actionRequired_action' ||
        campaignField.name === 'actionRequired_receive' ||
        campaignField.name === 'actionRequired_value') && _vm.hideRequiredActions())) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', {
        attrs: {
          "xs12": ""
        }
      }, _vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex,
          staticClass: "form-group col-xs-12 pa-0"
        }, _vm._l((campaignField.template), function(optionField) {
          return _c('element', {
            key: optionField.name
          }, [(optionField.type == 'text') ? _c('div', {
            staticClass: "form-group col-xs-12 pa-0 mb-0"
          }, [_c('h4', {
            staticClass: "mb-1"
          }, [_c('strong', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] ? 'Concept ' + (optionIndex + 1) + ': ' + _vm.campaign[campaignField.name][optionIndex][optionField.name] : 'Option ' + (optionIndex + 1)))])])]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea' && _vm.campaign[campaignField.name][optionIndex][optionField.name]) ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-12 mb-1 pb-0 pl-0"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('p', {
            staticStyle: {
              "white-space": "pre-line"
            }
          }, [_vm._v(_vm._s(!_vm.campaign[campaignField.name][optionIndex][optionField.name] ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'multiple_options') ? _c('div', _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(secondOption, secondOptionIndex) {
            return _c('div', {
              key: secondOptionIndex
            }, _vm._l((optionField.template), function(optionField2, optionIndex2) {
              return _c('v-layout', {
                key: optionIndex2,
                staticClass: "multiple-format",
                attrs: {
                  "wrap": ""
                }
              }, _vm._l((optionField2), function(format, i) {
                return _c('v-flex', {
                  key: i,
                  attrs: {
                    "xs6": ""
                  }
                }, [(format.type == 'text' && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) ? _c('div', {
                  staticClass: "form-group col-xs-12"
                }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] : '-'))])])]) : _vm._e(), _vm._v(" "), (format.type == 'textarea' && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) ? _c('div', {
                  staticClass: "form-group col-xs-12 pa-0 ma-0"
                }, [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('p', {
                  staticStyle: {
                    "white-space": "pre-line"
                  }
                }, [_vm._v(_vm._s(!_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]))])]) : _vm._e(), _vm._v(" "), (format.type === 'combobox' && Array.isArray(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name].length > 0) ? _c('div', {
                  staticClass: "form-group col-xs-12 pa-0 ma-0"
                }, [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), (Array.isArray(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name])) ? _c('div', _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]), function(value) {
                  return _c('v-chip', {
                    key: value,
                    staticClass: "ma-2"
                  }, [_vm._v(_vm._s(value))])
                }), 1) : _c('div', [_c('p', [_vm._v(_vm._s(!_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]))])])]) : _vm._e(), _vm._v(" "), (format.type == 'upload' && Array.isArray(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name].length > 0) ? _c('div', {
                  staticClass: "form-group col-xs-12 pa-0 ma-0 img-insp-block"
                }, [_c('div', {
                  staticClass: "col-12 pl-0"
                }, [_c('label', [_vm._v(_vm._s(format.label))])]), _vm._v(" "), _c('div', {
                  staticClass: "d-flex flex-sm-column flex-column"
                }, _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]), function(image) {
                  return _c('div', {
                    key: image,
                    staticClass: "pl-0"
                  }, [(image.type === 'image') ? _c('a', {
                    key: image,
                    staticClass: "campaign-image",
                    attrs: {
                      "href": _vm.constructImageURL(image.url),
                      "target": "_blank"
                    }
                  }, [_c('img', {
                    staticStyle: {
                      "width": "100%"
                    },
                    attrs: {
                      "src": _vm.constructImageURL(image.url)
                    }
                  })]) : _vm._e(), _vm._v(" "), (image.type === 'link') ? _c('a', {
                    key: image,
                    staticClass: "campaign-image",
                    attrs: {
                      "href": image.url,
                      "target": "_blank"
                    }
                  }, [(_vm.checkMediaURL(image.url) === 'drive') ? _c('iframe', {
                    staticClass: "media-iframe",
                    attrs: {
                      "width": "150px",
                      "height": "100%",
                      "src": image.url,
                      "allowFullScreen": ""
                    }
                  }) : _c('p', [_vm._v(_vm._s(image.url))])]) : _vm._e()])
                }), 0)]) : _vm._e()])
              }), 1)
            }), 1)
          }), 0) : _vm._e()])
        }), 0)
      }), 0) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.EVENT_BRIEF && _vm.showEventBrief && _vm.campaign.eventBrief) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'textarea') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(campaignField.label))])]), _vm._v(" "), _c('p', {
        staticStyle: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name]))])], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(campaignField.label))])]), _vm._v(" "), _vm._l((_vm.campaign.eventBrief[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": "",
              "md3": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e()])
        }), 1)], 1)], 1)
      })], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'template') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(campaignField.label))])]), _vm._v(" "), _c('v-container', [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, _vm._l((campaignField.template), function(templateField, i) {
        return _c('v-flex', {
          key: i,
          attrs: {
            "xs12": "",
            "md4": ""
          }
        }, [(templateField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name]))])]) : _vm._e(), _vm._v(" "), (templateField.type === 'radioButton') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes' : 'No'))])]) : _vm._e(), _vm._v(" "), (templateField.type === 'date' && templateField.name === 'eventDate') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name]))])]) : _vm._e(), _vm._v(" "), (templateField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', {
          staticStyle: {
            "white-space": "pre-wrap"
          }
        }, [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name]))])]) : _vm._e()])
      }), 1)], 1)], 1) : _vm._e()])
    }), 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.currentSectionSelected !== null) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('chatbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentSectionSelected.type === section.type),
        expression: "currentSectionSelected.type === section.type"
      }],
      attrs: {
        "messages": _vm.comments,
        "title": _vm.commentTitle,
        "readOnly": !_vm.isPendingCampaign
      },
      on: {
        "sendMessage": _vm.sendComment,
        "reloadMessage": _vm.viewComments
      }
    })], 1) : _vm._e()], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('am-cc-inputs-modal', {
    attrs: {
      "campaign": _vm.campaignData
    },
    model: {
      value: (_vm.amCCInputsDialog),
      callback: function($$v) {
        _vm.amCCInputsDialog = $$v
      },
      expression: "amCCInputsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-588762fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ViewCampaignModal.vue
// module id = 2138
// module chunks = 0